import React, { useState, useRef, useEffect } from 'react';
import { useCurrency } from '../contexts/CurrencyContext';
import '../styles/CurrencySelector.css';

const CurrencySelector = () => {
  const { selectedCurrency, changeCurrency, getCurrencySymbol, getCurrencyName, CURRENCIES } = useCurrency();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const currencyCodes = Object.keys(CURRENCIES);
  const selected = CURRENCIES[selectedCurrency];

  return (
    <div className="currency-selector" ref={dropdownRef}>
      <button
        className="currency-selector__button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Выбрать валюту"
      >
        <span className="currency-selector__symbol">{selected.symbol}</span>
        <span className="currency-selector__code">{selectedCurrency}</span>
        <svg className="currency-selector__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </button>
      
      {isOpen && (
        <div className="currency-selector__dropdown">
          {currencyCodes.map(code => {
            const currency = CURRENCIES[code];
            return (
              <button
                key={code}
                className={`currency-selector__option ${selectedCurrency === code ? 'active' : ''}`}
                onClick={() => {
                  changeCurrency(code);
                  setIsOpen(false);
                }}
              >
                <span className="currency-selector__symbol">{currency.symbol}</span>
                <span className="currency-selector__name">{currency.name}</span>
                <span className="currency-selector__code-small">({code})</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CurrencySelector;

